import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const RunDeliveryPage = lazy(() => import('~/features/catalog-enrichment/pages/run-delivery-page'));

/** A batch's Delivery tab — sent, accepted, live, what the destination refused and why. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/delivery',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunDeliveryPage runId={runId} />
    </Suspense>
  );
}
